
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class TenantUserDetail extends Vue {
  @Prop() user: any

  get statusType() {
    return {
        'is-success': this.user.status.id === 'ok',
        'is-warning': this.user.status.id === 'unconfirmed',
        'is-danger': this.user.status.id === 'deactivated'
      }
  }

  get nextSurvey() {
    return moment(this.user.deliverySurveyDate).format('LL')
  }

  @Emit('sendInvite')
  sendInvite() {
    return this.user
  }
}
